<template>
  <div class="playEndGuideContainer" v-if="streamingInfo !== undefined">
    <div class="text" v-if="streamingInfo !== undefined"> {{streamingInfo.exittitle}}  </div>
    <div class="desc" v-if="streamingInfo !== undefined" v-html='content'> </div>
    <div class="btnArea" v-if="streamingInfo.exitbtn === 'login,join'">
      <ul>
        <li><div class="btnType01 " @click.prevent="showLogin">로그인</div></li>
        <li><div class="btnType01 " @click.prevent="showAccount">회원가입</div></li>
      </ul>
    </div>
    <div class="btnArea" v-if="streamingInfo.exitbtn === 'purchase,confirm' || streamingInfo.exitbtn === 'purchase,cancel'">
      <ul>
        <li><div class="btnType01 " @click.prevent="showVoucher">구매하기</div></li>
        <li><div class="btnType01 " @click.prevent="clsoePopup">확인</div></li>
      </ul>
    </div>
    <div class="close" @click.prevent="clsoePopup"></div>
    <div class="dim"></div>
  </div>
</template>

<script>
export default {
  name: 'PlayEndGuide',
  props: {
    streamingInfo: {
      type: Object
    },
    closePlayEndGuidePopup: {
      type: Function
    },
    contentInfo: {
      type: Object
    },
    programId: {
      type: String
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String
    },
  },
  methods: {
    showLogin () {
      this.$router.push({ name: 'login', query: { referer: this.$route.fullPath } })
      this.clsoePopup()
    },
    showAccount () {
      this.clsoePopup()
      let encodeLocationHref = encodeURIComponent(window.location.href)
      location.href = 'https://member.wavve.com/mobile/account?returnurl=' + encodeLocationHref
      // alert('회원가입은 스마트폰을 이용해 wavve 모바일웹(http://familyhub.pooq.co.kr)에서 진행해 주세요.')
    },
    showVoucher () {
      //this.$router.push({ name: 'voucher' })
      this.$router.push({
        name: 'voucher_popup_new_for_app',
        params: {
         'cpid': this.contentInfo.cpid,
         'channelid': this.contentInfo.channelid,
         'programid': this.programId,
         'contentid': this.contentId,
         'contenttype': this.contentType
       }
     })
    },
    clsoePopup () {
      this.closePlayEndGuidePopup()
    }
  },
  computed: {
    content: function () {
      if (this.streamingInfo.exitmsg !== '' && typeof this.streamingInfo.exitmsg === 'string') {
        return this.streamingInfo.exitmsg.split('\n').join('<br />')
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
  .playEndGuideContainer { position: absolute; top:40px; left:0px;  width: 100%;   height: 225px;   z-index: 1999;  }
  .playEndGuideContainer .text{font-size:20px;position: absolute; top:40px; left:0px; width:100%;text-align:center; color: #ffffff; z-index: 1; }
  .playEndGuideContainer .desc{font-size:12px; position: absolute; top:77px; left:0px; width:100%;text-align:center; color: #ffffff; z-index: 1; }
  .playEndGuideContainer .btnArea{ position: absolute; top:151px; left:0px; width: 100%; z-index: 1;  }
  .playEndGuideContainer .btnArea ul { text-align:center;}
  .playEndGuideContainer .btnArea li { display:inline-block; margin: 0 10px 0 0}
  .playEndGuideContainer .btnArea li:last-child .btnType01{ margin-right: 0}
  .playEndGuideContainer .close { position: absolute; top:10px; left:355px; background: url(../../assets/images/ic-popup-close.png) no-repeat; width: 24px; height: 24px; background-size:100% 100%; z-index: 1}
  .dim {background-color: #000; opacity: 0.9;position: absolute; top:0px; left:0px; width: 100%; height: 305px; }
</style>
